var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('Header'),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"detail"},[_c('router-view')],1)]),_c('Footer'),_c('cookie-law')],1)}
var staticRenderFns = []

export { render, staticRenderFns }